import './App.css';
import Header from './components/layout/Header';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Blog from './components/Blog';
import Footer from './components/layout/Footer';
function App() {
  return (
    <>
      <Header />
      <Hero />
      <About />
      <Services />
      <Blog />
      <Footer />
    </>
  );
}

export default App;
